import { FC } from "react";
import cx from "classnames";

import Button from "./../../libs/Button";
import { IconTypes } from "./../../libs/Icon";
import useSideBar from "./../../hooks/useSideBar";
import RouterView from "./../../libs/RouterView";
import { sideBarRoutes } from "./../routes/config";
import EditModeSideBarLoading from "./Fields/EditModeSideBarLoading";

import styles from "./styles.module.scss";

const SideBar: FC = () => {
    const { onToggle, isOpen: isSideBarOpen } = useSideBar();

    return (
        <aside className={cx(styles.wrapper, { [styles.open]: isSideBarOpen, [styles.closed]: !isSideBarOpen })}>
            <Button
                className={cx(styles.sidebarToggler, { [styles.closed]: !isSideBarOpen })}
                icon={IconTypes.PREVIOUS}
                iconSize={24}
                onClick={onToggle}
            />

            <RouterView routes={sideBarRoutes} fallback={EditModeSideBarLoading} />
        </aside>
    );
};

export default SideBar;
